function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#Some_svg__filter0_d)"
}, React.createElement("rect", {
  x: 2,
  y: 1,
  width: 16,
  height: 16,
  rx: 4,
  fill: "url(#Some_svg__paint0_linear)"
}), React.createElement("rect", {
  x: 2.5,
  y: 1.5,
  width: 15,
  height: 15,
  rx: 3.5,
  stroke: "#000",
  strokeOpacity: 0.051
}));

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 6,
  y: 8,
  width: 8,
  height: 2,
  rx: 1,
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "Some_svg__paint0_linear",
  x1: 2,
  y1: 1,
  x2: 2,
  y2: 17,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4DB1FD"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#148CFC"
})), React.createElement("filter", {
  id: "Some_svg__filter0_d",
  x: 0,
  y: 0,
  width: 20,
  height: 20,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  "in": "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), React.createElement("feOffset", {
  dy: 1
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0784314 0 0 0 0 0.54902 0 0 0 0 0.988235 0 0 0 0.501038 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), React.createElement("feBlend", {
  "in": "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgSome = function SvgSome(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
};

export default SvgSome;